import { render, staticRenderFns } from "./ConversationStarters.vue?vue&type=template&id=e6c26a7e&"
import script from "./ConversationStarters.vue?vue&type=script&lang=js&"
export * from "./ConversationStarters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports